import '../scss/common.scss';

var hash = location.hash;
var winFlag;

$(function(){
  $('.js-menu-open').on('click', function() {
    $(this).toggleClass('is-open');
    $('.global-nav').slideToggle();
  });
  
  const mediaQuery = window.matchMedia('(min-width: 1180px)')
  if (mediaQuery.matches) {
    $('.global-nav-list .js-open').hover(function() {
      $(this).addClass('is-open');
    }, function() {
      $(this).removeClass('is-open');
    });
  }

});


// ロード＆リサイズ時
$(window).on('load resize', function() {
  var windowWidth = window.innerWidth;
  if (windowWidth >= 1180 && winFlag !== 'pc') {
    $('body').removeClass('sp');
    $('body').removeClass('tab');
    $('body').addClass('pc');
    winFlag = 'pc';
  } else if ((windowWidth > 767 && windowWidth < 1180) && winFlag !== 'tab') {
    $('body').removeClass('sp');
    $('body').removeClass('pc');
    $('body').addClass('tab');
    winFlag = 'tab';
  } else if (windowWidth <= 767 && winFlag !== 'sp') {
    $('body').removeClass('tab');
    $('body').removeClass('pc');
    $('body').addClass('sp');
    winFlag = 'sp';
  }
});




$(window).on('load', function() {

  // グロナビ
  if ( $('body').hasClass('pc') ) {
    $('.global-nav-list .js-open').hover(function() {
      $(this).addClass('is-open');
    }, function() {
      $(this).removeClass('is-open');
    });
  }
  if ( $('body').hasClass('tab') ) {
    $('.global-nav-list .js-open').on('click', function() {
      $(this).toggleClass('is-open');
      $(this).find('.sub-list').slideToggle();
    });
  }
  if( $('body').hasClass('sp') ) {
    $('.global-nav-list .js-open').on('click', function() {
      $(this).toggleClass('is-open');
      $(this).find('.sub-list').slideToggle();
    });
  }
  /*$('.js-menu-open').on('click', function() {
    $(this).toggleClass('is-open');
    $('.global-nav').slideToggle();
  });*/

  // 画像モーダル
  if ( $('.popup')[0] ) {
    $('.popup').magnificPopup({
      delegate: 'a',
      type: 'image',
      gallery: {
        enabled: true,
        navigateByImgClick: true,
        preload: [0,1]
      },
      image: {
        titleSrc: function(item) {
          return item.el.attr('title');
        }
      },
      zoom: {
        enabled: true,
        duration: 300
      }
    });
  }

  // 動画モーダル
  if ( $('.popup-iframe')[0] ) {
    $('.popup-iframe').magnificPopup({
      type: 'iframe',
      disableOn: 500,
      mainClass: 'mfp-fade',
      removalDelay: 200,
      preloader: false,
      fixedContentPos: false
    });
  }


  // tableスクロール
  if ( $('.table-scroll')[0] ) {
    $('.table-scroll').wrap('<div class="table-wrap" />');
  }

  // リスト表示
  if ( $('.js-list-show')[0] ) {
    $('[class*="js-page"]').not('.js-page-1').css('display', 'none');
    $('.js-list-show').on('click', function(e) {
      e.preventDefault();
      var page = parseInt($(this).data('page'));
      var last = parseInt($(this).data('last'));
      page++;
      $('.js-page-'+page).show();
      $(this).data('page', page)
      if ( page >= last ) {
        $(this).hide();
      }
    });
  }

  // ニュース
  if ( $('.display-switch')[0] ) {
    $('.js-display-switch').on('click', function() {
      var display = $(this).data('display');
      $('.news-main-contents').removeClass(function(index, className) {
        return (className.match(/\bis-display-\S+/g) || []).join(' ');
      });
      $('.news-main-contents').addClass('is-display-' + display);
      $('.js-display-switch').removeClass('is-active');
      $(this).addClass('is-active');
    });
  }
  if ( $('.news-contents')[0] ) {
    $('.news-contents-body').find('a').each(function() {
      $('.news-contents-body a[href^=http]').not('[href*="'+location.hostname+'"]').attr({target:'_blank'}).addClass('ico_blank');
    });
  }

  // 試合写真
  if ( $('.js-masonry')[0] ) {
    var $grid = jQuery('.js-masonry').imagesLoaded(function(){
      $grid.masonry({
        itemSelector: '.js-masonry-item'
      });
    });
  }

  // スライダ
  if ( $('.js-slider')[0] ) {
    $('.js-slider').slick({
      autoplay: false,
      autoplaySpeed: 5000,
      cssEase: 'linear',
      dots: true,
      pauseOnHover: false,
      speed: 1000,
      prevArrow: '.js-slider-arrow--prev',
      nextArrow: '.js-slider-arrow--next'
    })
    .on('beforeChange',function(event, slick, currentSlide, nextSlide){
      if(nextSlide > 0 ) {
        $(this).slick('slickSetOption', 'autoplaySpeed', 4000);
      }
    });
  }

  // スムーススクロール
  $('a[href^="#"]:not(".noscroll")').on('click', function() {
    var href     = $(this).attr("href");
    var target   = $(href == "#" || href == "" ? "html" : href);
    scrollToAnker(target);
    return false;
   });
  /*if ( hash ) {//別ページからの遷移時に#タグがあった場合
    $('body,html').stop().scrollTop(0);
    setTimeout(function () {
      scrollToAnker(hash);
    }, 100);
  }*/
});

function scrollToAnker(hash) {
  var speed    = 500; // ミリ秒
  var target   = $(hash);
  var position = target.offset().top;
  $("body,html").stop().animate({scrollTop:position}, speed, "swing");
}


// ロード＆スクロール時
$(window).on('load scroll', function() {
  if ( $('.js-fixed-menu')[0] ) {
    var windowScrollTop       = $(window).scrollTop();
    var windowHeight          = $(window).innerHeight();
    var menuWrapperOffsetTop  = $('.js-menu-wrap').offset().top;
    var menuWrapperPaddingTop = parseInt($('.js-menu-wrap').css('padding-top'));
    var menuOffsetTop         = $('.js-fixed-menu').offset().top;
    var menuHeight            = $('.js-fixed-menu').height();
    var footerOffsetTop       = $('.global-footer').offset().top;
    if ( windowHeight < ( menuOffsetTop + menuHeight ) ) {
      if ( ( windowScrollTop + windowHeight ) >= ( menuOffsetTop + menuHeight ) ) {
        $('.js-fixed-menu').addClass('is-fixed');
      }
      if ( menuOffsetTop < (menuWrapperOffsetTop + menuWrapperPaddingTop) ) {
        $('.js-fixed-menu').removeClass('is-fixed');
      }
    } else {
      $('.js-fixed-menu').addClass('is-fixed');
    }
    // $('.js-fixed-menu').addClass('is-fixed');
    if ( ( windowScrollTop + windowHeight ) > footerOffsetTop ) {
      $('.js-fixed-menu').addClass('is-absolute');
    } else {
      $('.js-fixed-menu').removeClass('is-absolute');
    }
  }
});
